<template>
  <a-modal
    v-model="visible"
    :title="null"
    :maskClosable="true"
    :okText="$t('com_btn_create')"
    :width="800"
    forceRender
    destroyOnClose
    :bodyStyle="{ padding: 0, borderRadius: '15px' }"
    :closable="false"
    :footer="null"
    centered
  >
    <div class="alarm-list">
      <a-table
        :columns="columns"
        :data-source="alarmList"
        :scroll="{ y: tableHeight }"
        :pagination="false"
        :rowKey="(text, index) => index"
        bordered
        size="small"
      >
        <!-- 告警级别 -->
        <template slot="lev" slot-scope="text">
          <span v-if="text === 0" style="color: #333">
            {{ $t('device_alarm_type_oa') }}
          </span>
          <span v-if="text === 1" style="color: #98b912">
            {{ $t('device_alarm_type_ma') }}
          </span>
          <span v-if="text === 2" style="color: red">
            {{ $t('device_alarm_type_ca') }}
          </span>
        </template>

        <!-- 时间 -->
        <template slot="start_tm" slot-scope="text">
          <span v-if="text">{{ text | formatDate('yyyy-MM-dd HH:mm:ss', true) }}</span>
        </template>
      </a-table>
    </div>
    <div class="alarm-footer">
      <a-button type="default" @click="close">
        {{ $t('com_btn_close') }}
      </a-button>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    callback: {
      type: Function,
      default: () => {},
    },
    tableHeight: {
      type: Number,
      default: 720,
    },
  },
  data() {
    return {
      // 新增
      visible: false,

      // 告警
      columns: [
        {
          title: this.$t('com_table_index'),
          customRender: (text, record, index) => `${index + 1}`,
          align: 'center',
        },
        {
          title: this.$t('device_alarm_level'),
          dataIndex: 'lev',
          align: 'center',
          scopedSlots: { customRender: 'lev' },
          width: 100,
        },
        {
          title: this.$t('device_alarm_name'),
          dataIndex: 'name',
        },
        {
          title: this.$t('device_alarm_src'),
          dataIndex: 'src',
        },
        {
          title: this.$t('device_alarm_time'),
          dataIndex: 'start_tm',
          align: 'center',
          width: 170,
          scopedSlots: { customRender: 'start_tm' },
        },
      ],
      alarmList: [],
    };
  },
  methods: {
    show(alarmList) {
      this.visible = true;
      this.alarmList = alarmList;
    },

    close() {
      this.visible = false;
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .alarm-list {
  .ant-table-header {
    border-radius: 0;
  }
}

.alarm-footer {
  padding: 20px 15px;
  display: flex;
  justify-content: flex-end;
  button {
    margin-left: 15px;
  }
}
</style>
